import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { DeviceModel } from 'src/app/models/entities/device-model';
import { Portal } from 'src/app/models/entities/portal';
import { Terminal } from 'src/app/models/entities/terminal';
import { DeviceModelService } from 'src/app/services/device-model.service';
import { NbsUserService } from 'src/app/services/nbs-user.service';
import { PortalService } from 'src/app/services/portal.service';
import { TerminalService } from 'src/app/services/terminal.service';

@Component({
  selector: 'app-terminal-update',
  templateUrl: './terminal-update.component.html',
  styleUrls: ['./terminal-update.component.css']
})
export class TerminalUpdateComponent implements OnInit {

  destroy$ = new Subject<void>();
  portals$: Observable<Portal[]>;
  deviceModels$: Observable<DeviceModel[]>;
  form: FormGroup;
  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private terminalService: TerminalService,
    private portalService: PortalService,
    private deviceModelService: DeviceModelService,
    private userService: NbsUserService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.loadDatas();
    this.getTerminalById();
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      terminalId: ["", Validators.required],
      imei: [""],
      portalId: ["", Validators.required],
      deviceModelId: [""],
      terminalStatus: false,
      isActive: true
    })
  }


  loadDatas() {
    this.portals$ = this.portalService.getList().pipe(map(result => result.data));
    this.deviceModels$ = this.deviceModelService.getList().pipe(map(result => result.data));
  }

  getTerminalById() {
    const terminalId = parseInt(this.activatedRoute.snapshot.paramMap.get('terminalId'));
    this.terminalService.getById(terminalId).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.form.patchValue(data.data);
    })
  }

  update() {
    if (this.form.valid) {
      const terminal: Terminal = this.form.getRawValue();
      terminal.deviceModelId = (terminal.deviceModelId  === null || terminal.deviceModelId  === undefined) ? 0 : terminal.deviceModelId;
      terminal.userId = this.userService.getUserId();
      this.terminalService.update(terminal).pipe(takeUntil(this.destroy$)).subscribe(
        () => {
          this.toastrService.success("Terminal kayıt işlemi başarıyla gerçekleştirildi.", "Başarılı");
          this.router.navigateByUrl('/terminal');
        },
        er => {
          this.toastrService.error(er.error.message, "Hata!");
        }
      );
    }
  }



  ngOnDestroy(): void {
    this.destroy$.next();
  }



}
